export const WORKOUT_SECTION_CONSTS = {
    GET_WORKOUT_SECTIONS: "GET_WORKOUT_SECTIONS",
    CREATE_WORKOUT_SECTION: "CREATE_WORKOUT_SECTION",
    GET_WORKOUT_SECTION_BY_ID: "GET_WORKOUT_SECTION_BY_ID",
    UPDATE_WORKOUT_SECTION_BY_ID: "UPDATE_WORKOUT_SECTION_BY_ID",
    DELETE_WORKOUT_SECTION_BY_ID: "DELETE_WORKOUT_SECTION_BY_ID",
};